
export const getLanguageFromULocale = (language: string) => {
  return language.split('_')[0];
}
